import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { GlobalVariablesService } from '../../../services/global-variables.service';
import { LoginHistoryVm } from '../../../shared/generated/Administration/Models/LoginHistoryVm';

@Component({
    selector: 'pcg-user-login-history',
    templateUrl: './user-login-history.component.html',
    styleUrls: ['./user-login-history.component.scss'],
    standalone: false
})
export class UserLoginHistoryComponent implements OnInit {

	@Input() id: number;

	columns = LoginHistoryVm.ColumnDefs;	

	fullName: string;

	constructor(
		private activatedRoute: ActivatedRoute
		, private gvs: GlobalVariablesService
	) { }

	ngOnInit() { if (this.id == null) { this.id = this.activatedRoute.snapshot.params.id; } }

	setUserName(event) {
		this.fullName = event.value;
		this.gvs.userName.set(event.value);
	}
}
